import { useCallback, useEffect, useState } from 'react'
import useInterval from '../useInterval'

// utils
import { isApprovedForAll } from '../../sushi/utils'
import { userNFTContract } from '../../userType/userNFTContract'
import { userBidNFTContract } from '../../userType/userBidNFTContract'
import { userNFTMasterContract } from '../../userType/userNFTMasterContract'

import { MARKETTYPE, MARKETMULTITOKEN, MARKETTYPEV1, MARKETTYPEV3 } from '../../constants/bakery/nft'
import { multiTokenExchangeNftContract } from '../../userType/multiTokenExchangeNftContract'

// hooks
import useYam from '../bakery/useYam'
import { useActiveWeb3React } from '../'
import { userExchangeNFTContract } from '../../userType/userExchangeNFTContract'
import { userV3NFTContract } from '../../userType/userV3NFTContract'

const useAllowanceAll = (
  {
    type,
    marketFlag,
    requested,
    // reset
  }: {
    type: string,
    marketFlag?: string
    requested?: boolean,
    // reset?: boolean
  }
) => {
  const [allowance, setAllowance] = useState(false)
  const { account } = useActiveWeb3React()
  const sushi = useYam()

  let erc721Contract = userNFTContract(sushi, type)
  let contract: any
  if(marketFlag === 'market'){
    if(type && MARKETTYPE.hasOwnProperty(type)){
      contract = userBidNFTContract(sushi, type)
    }else if(type && MARKETMULTITOKEN.hasOwnProperty(type)){
      contract = multiTokenExchangeNftContract(sushi, type)
    }else if(type && MARKETTYPEV1.hasOwnProperty(type)){
      contract = userExchangeNFTContract(sushi, type)
    }else if(type && MARKETTYPEV3.hasOwnProperty(type)){
      contract = userV3NFTContract(sushi, type)
    }
  } else {
    // console.log("---1111111111111--",type)
    contract = userNFTMasterContract(sushi, type)
    // console.log("---1111111111111contract--",contract._address)
  }

  const fetchAllowance = useCallback(async () => {
    try {
      const tx = await isApprovedForAll(account, erc721Contract, contract)
      setAllowance(tx)
    } catch (e) {
      setAllowance(false)
    }
  }, [account, contract, erc721Contract])

  useEffect(() => {
    if (account) {
      fetchAllowance()
    }
  }, [account, fetchAllowance])

  useInterval(fetchAllowance, !allowance ? 3000 : null)


  return allowance
}

export default useAllowanceAll
